// 样式管理工具类
class StyleManager {
  constructor() {
    this.styleConfig = null;
    this.styleElement = null;
    this.storageKey = 'store-theme-config';
  }

  // 初始化样式管理器
  init() {
    this.createStyleElement();
    this.restoreStyleConfig();
  }

  // 创建样式元素
  createStyleElement() {
    if (!this.styleElement) {
      this.styleElement = document.createElement('style');
      this.styleElement.id = 'dynamic-styles';
      document.head.appendChild(this.styleElement);
    }
  }

  // 更新样式配置
  updateStyleConfig(config) {
    this.styleConfig = this.normalizeConfig(config);
    this.saveStyleConfig();
    this.applyStyles();
  }

  // 应用样式到页面
  applyStyles() {
    if (!this.styleConfig || !this.styleElement) return;

    const cssRules = this.generateCSSRules();
    this.styleElement.innerHTML = cssRules;
  }

  // 生成CSS规则
  generateCSSRules() {
    const { primaryColor, backgroundColor, textColor, linkColor, buttonColor } = this.styleConfig || {};
    
    const blackBg = '#0B0B0B'
    return `
      /* 动态样式配置 */
      :root {
        --primary-color: ${primaryColor || '#486AFF'};
        --background-color: ${backgroundColor || blackBg};
        --text-color: ${textColor || '#486AFF'};
        --link-color: ${linkColor || '#808080'};
        --button-color: ${buttonColor || '#486AFF'};
		    --pupop-bg-color: ${backgroundColor === blackBg ? '#26292C' : '#ffffff'};
	    	--select-border-color: ${backgroundColor === blackBg ? '#373737' : '#E8E8E9'};
	    	--select-color: ${backgroundColor === blackBg ? '#ffffff' : '#373737'};
	  	  --select-bg-color: ${backgroundColor === blackBg ? '#26292C' : '#E8E8E9'};
        --border-color: ${backgroundColor === blackBg ? '#ffffff' : '#37373721'};
        --font-color--black: ${blackBg};
        --font-color--whit: #fff;
      }

      /* 应用动态样式 */
      body {
        background-color: var(--background-color) !important;
        color: var(--text-color) !important;
      }

      .el-button--primary {
        background-color: var(--button-color) !important;
        border-color: var(--button-color) !important;
      }

      .el-button--primary:hover {
        background-color: ${this.lightenColor(buttonColor || '#486AFF', 10)} !important;
        border-color: ${this.lightenColor(buttonColor || '#486AFF', 10)} !important;
      }

      a {
        color: var(--select-color) !important;
      }

      a:hover {
        color: var(--primary-color) !important;
      }

      .search-button {
        background-color: var(--button-color) !important;
      }

      .search-button:hover {
        background-color: ${this.lightenColor(buttonColor || '#486AFF', 10)} !important;
      }

      /* 其他组件样式可以根据需要添加 */
    `;
  }

  // 颜色变亮函数
  lightenColor(color, percent) {
    if (!color) return '#409EFF';
    
    // 简单的颜色变亮实现
    if (color.startsWith('#')) {
      const hex = color.replace('#', '');
      const num = parseInt(hex, 16);
      const amt = Math.round(2.55 * percent);
      const R = (num >> 16) + amt;
      const G = (num >> 8 & 0x00FF) + amt;
      const B = (num & 0x0000FF) + amt;
      
      return '#' + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 +
        (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 +
        (B < 255 ? B < 1 ? 0 : B : 255)).toString(16).slice(1);
    }
    
    return color;
  }

  // 获取当前样式配置
  getCurrentConfig() {
    return this.styleConfig;
  }

  // 统一配置字段，兼容旧字段命名
  normalizeConfig(config = {}) {
    const primaryColor = config.primaryColor || config.themeColor || '#486AFF';
    const backgroundColor = config.backgroundColor || config.bgColor || '#0B0B0B';

    return {
      primaryColor,
      themeColor: primaryColor,
      backgroundColor,
      bgColor: backgroundColor,
      textColor: config.textColor || config.selectFontColor || primaryColor,
      linkColor: config.linkColor || config.noselectFontColor || '#808080',
      buttonColor: config.buttonColor || primaryColor
    };
  }

  // 缓存当前主题，刷新后可立即恢复 CSS 变量
  saveStyleConfig() {
    try {
      if (!this.styleConfig || typeof localStorage === 'undefined') return;
      localStorage.setItem(this.storageKey, JSON.stringify(this.styleConfig));
    } catch (error) {
      // localStorage 不可用时静默失败，不影响页面主流程
    }
  }

  // 读取缓存主题并重新注入到页面
  restoreStyleConfig() {
    try {
      if (typeof localStorage === 'undefined') return;
      const cache = localStorage.getItem(this.storageKey);
      if (!cache) return;
      const parsedConfig = JSON.parse(cache);
      this.styleConfig = this.normalizeConfig(parsedConfig);
      this.applyStyles();
    } catch (error) {
      // 缓存损坏时忽略并继续使用默认样式
    }
  }

  // 重置为默认样式
  resetToDefault() {
    this.styleConfig = null;
    try {
      if (typeof localStorage !== 'undefined') {
        localStorage.removeItem(this.storageKey);
      }
    } catch (error) {
      // localStorage 不可用时静默失败
    }
    if (this.styleElement) {
      this.styleElement.innerHTML = '';
    }
  }
}

// 创建全局样式管理器实例
const styleManager = new StyleManager();

// 初始化样式管理器
styleManager.init();

export default styleManager;